import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const PLANS = [
  {
    id: 'free',
    name: 'NordPass Gratis',
    price: '0,00 NOK',
    priceNum: 0,
    period: 'per måned',
    color: '#2EC4A0',
    icon: 'Gift',
    vehicles: 'Opptil 1 kjøretøy',
    features: [
      'Grunnleggende bompassering',
      '1 kjøretøy',
      'Fakturahistorikk',
      'E-poststøtte',
    ],
    notIncluded: [
      'Prioritert kundestøtte',
      'Avansert ruteplanlegging',
      'Rabatter på bompenger',
      'Ubegrenset kjøretøy',
    ],
  },
  {
    id: 'normal',
    name: 'NordPass Normal',
    price: '149,00 NOK',
    priceNum: 149,
    period: 'per måned',
    color: '#3B6FD4',
    icon: 'Star',
    vehicles: 'Opptil 3 kjøretøy',
    popular: false,
    features: [
      'Alt i Gratis',
      'Opptil 3 kjøretøy',
      'Avansert ruteplanlegging',
      'Prioritert e-poststøtte',
      '10% rabatt på bompenger',
    ],
    notIncluded: [
      'Ubegrenset kjøretøy',
      'Dedikert kontoadministrator',
    ],
  },
  {
    id: 'premium',
    name: 'NordPass Premium',
    price: '299,00 NOK',
    priceNum: 299,
    period: 'per måned',
    color: '#E8941A',
    icon: 'Crown',
    vehicles: 'Opptil 5 kjøretøy',
    popular: true,
    features: [
      'Alt i Normal',
      'Opptil 5 kjøretøy',
      'Dedikert kontoadministrator',
      '20% rabatt på bompenger',
      'Prioritert telefonstøtte',
      'Tidlig tilgang til nye funksjoner',
    ],
    notIncluded: [],
  },
];

const generatePDF = async (billingInfo, plan, invoiceNumber, date) => {
  try {
    const { jsPDF } = await import('jspdf');
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    const W = 210;
    const margin = 20;

    // Header bar
    doc?.setFillColor(15, 17, 23);
    doc?.rect(0, 0, W, 297, 'F');
    doc?.setFillColor(26, 46, 82);
    doc?.rect(0, 0, W, 52, 'F');
    doc?.setFillColor(59, 111, 212);
    doc?.rect(0, 0, W, 4, 'F');

    // Logo text
    doc?.setFont('helvetica', 'bold');
    doc?.setFontSize(22);
    doc?.setTextColor(238, 240, 242);
    doc?.text('NORDPASS', margin, 28);

    doc?.setFont('helvetica', 'normal');
    doc?.setFontSize(9);
    doc?.setTextColor(138, 149, 163);
    doc?.text('NordPass AS  ·  Org.nr: 123 456 789  ·  post@nordpass.no', margin, 36);
    doc?.text('Storgata 1, 0155 Oslo, Norge', margin, 42);

    // Invoice label top right
    doc?.setFont('helvetica', 'bold');
    doc?.setFontSize(28);
    doc?.setTextColor(59, 111, 212);
    doc?.text('FAKTURA', W - margin, 28, { align: 'right' });

    doc?.setFontSize(9);
    doc?.setTextColor(138, 149, 163);
    doc?.text(`Nr: ${invoiceNumber}`, W - margin, 36, { align: 'right' });
    doc?.text(`Dato: ${date}`, W - margin, 42, { align: 'right' });

    // Divider
    doc?.setDrawColor(59, 111, 212);
    doc?.setLineWidth(0.5);
    doc?.line(margin, 56, W - margin, 56);

    // Bill to section
    let y = 66;
    doc?.setFont('helvetica', 'bold');
    doc?.setFontSize(8);
    doc?.setTextColor(138, 149, 163);
    doc?.text('FAKTURERES TIL', margin, y);

    y += 6;
    doc?.setFont('helvetica', 'bold');
    doc?.setFontSize(12);
    doc?.setTextColor(238, 240, 242);
    doc?.text(`${billingInfo?.fullName || ''}`, margin, y);

    y += 6;
    doc?.setFont('helvetica', 'normal');
    doc?.setFontSize(10);
    doc?.setTextColor(200, 205, 210);
    if (billingInfo?.address) { doc?.text(billingInfo?.address, margin, y); y += 5; }
    if (billingInfo?.postalCode || billingInfo?.city) {
      doc?.text(`${billingInfo?.postalCode || ''} ${billingInfo?.city || ''}`?.trim(), margin, y);
      y += 5;
    }
    if (billingInfo?.phone) { doc?.text(`Tlf: ${billingInfo?.phone}`, margin, y); y += 5; }
    if (billingInfo?.email) { doc?.text(billingInfo?.email, margin, y); y += 5; }

    // Plan summary box
    y += 8;
    doc?.setFillColor(22, 27, 36);
    doc?.rect(margin, y, W - margin * 2, 8, 'F');
    doc?.setFillColor(26, 46, 82);
    doc?.rect(margin, y, W - margin * 2, 8, 'F');

    doc?.setFont('helvetica', 'bold');
    doc?.setFontSize(8);
    doc?.setTextColor(138, 149, 163);
    doc?.text('BESKRIVELSE', margin + 4, y + 5.5);
    doc?.text('PERIODE', 110, y + 5.5);
    doc?.text('BELØP', W - margin - 4, y + 5.5, { align: 'right' });

    y += 12;
    doc?.setFillColor(22, 27, 36);
    doc?.rect(margin, y - 2, W - margin * 2, 12, 'F');

    doc?.setFont('helvetica', 'normal');
    doc?.setFontSize(10);
    doc?.setTextColor(238, 240, 242);
    doc?.text(plan?.name || '', margin + 4, y + 6);
    doc?.text('1 måned', 110, y + 6);
    doc?.setFont('helvetica', 'bold');
    doc?.text(plan?.price || '', W - margin - 4, y + 6, { align: 'right' });

    y += 16;
    doc?.setDrawColor(59, 111, 212, 0.3);
    doc?.setLineWidth(0.3);
    doc?.line(margin, y, W - margin, y);

    // Total
    y += 8;
    doc?.setFont('helvetica', 'bold');
    doc?.setFontSize(11);
    doc?.setTextColor(138, 149, 163);
    doc?.text('TOTALT', W - margin - 40, y);
    doc?.setFontSize(14);
    doc?.setTextColor(232, 148, 26);
    doc?.text(plan?.price || '', W - margin - 4, y, { align: 'right' });

    // MVA note
    y += 6;
    doc?.setFont('helvetica', 'normal');
    doc?.setFontSize(8);
    doc?.setTextColor(138, 149, 163);
    doc?.text('MVA 25% inkludert', W - margin - 4, y, { align: 'right' });

    // Payment info
    y += 16;
    doc?.setFillColor(22, 27, 36);
    doc?.rect(margin, y, W - margin * 2, 28, 'F');
    doc?.setDrawColor(59, 111, 212);
    doc?.setLineWidth(0.3);
    doc?.rect(margin, y, W - margin * 2, 28);

    doc?.setFont('helvetica', 'bold');
    doc?.setFontSize(8);
    doc?.setTextColor(59, 111, 212);
    doc?.text('BETALINGSINFORMASJON', margin + 4, y + 6);

    doc?.setFont('helvetica', 'normal');
    doc?.setFontSize(9);
    doc?.setTextColor(200, 205, 210);
    doc?.text('Kontonummer: 1234 56 78901', margin + 4, y + 13);
    doc?.text('KID: ' + invoiceNumber?.replace('NP-', ''), margin + 4, y + 19);
    doc?.text('Forfallsdato: 14 dager fra fakturadato', margin + 4, y + 25);

    // Footer
    doc?.setFillColor(10, 13, 18);
    doc?.rect(0, 275, W, 22, 'F');
    doc?.setFont('helvetica', 'normal');
    doc?.setFontSize(7.5);
    doc?.setTextColor(138, 149, 163);
    doc?.text('NordPass AS  ·  Storgata 1, 0155 Oslo  ·  post@nordpass.no  ·  nordpass.no', W / 2, 283, { align: 'center' });
    doc?.text('Org.nr: 123 456 789  ·  MVA-nr: NO123456789MVA', W / 2, 289, { align: 'center' });

    doc?.save(`${invoiceNumber}.pdf`);
  } catch (err) {
    console.error('PDF generation error:', err);
  }
};

const inputStyle = {
  width: '100%',
  padding: '10px 14px',
  background: '#0F1117',
  border: '1px solid rgba(138,149,163,0.2)',
  color: '#EEF0F2',
  fontFamily: 'Inter, sans-serif',
  fontSize: '0.875rem',
  outline: 'none',
  boxSizing: 'border-box',
  transition: 'border-color 150ms ease',
};

const labelStyle = {
  fontFamily: 'Inter, sans-serif',
  fontSize: '0.75rem',
  fontWeight: 600,
  color: '#8A95A3',
  display: 'block',
  marginBottom: '6px',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
};

const UpgradePlanModal = ({ isOpen, onClose, currentPlan, onUpgrade, isLoading, userEmail }) => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [step, setStep] = useState('select'); // 'select' | 'billing' | 'confirm'
  const [billingInfo, setBillingInfo] = useState({
    fullName: '',
    address: '',
    postalCode: '',
    city: '',
    phone: '',
    email: userEmail || '',
    company: '',
    orgNumber: '',
  });
  const [billingErrors, setBillingErrors] = useState({});
  const [isClosing, setIsClosing] = useState(false);
  const [shakeKey, setShakeKey] = useState(0);

  if (!isOpen) return null;

  const handleSelectPlan = (plan) => {
    if (plan?.name === currentPlan) return;
    setSelectedPlan(plan);
  };

  const handleContinue = () => {
    if (!selectedPlan) return;
    if (selectedPlan?.priceNum === 0) {
      setStep('confirm');
    } else {
      setStep('billing');
    }
  };

  const validateBilling = () => {
    const errors = {};
    if (!billingInfo?.fullName?.trim()) errors.fullName = 'Påkrevd';
    if (!billingInfo?.address?.trim()) errors.address = 'Påkrevd';
    if (!billingInfo?.postalCode?.trim()) errors.postalCode = 'Påkrevd';
    if (!billingInfo?.city?.trim()) errors.city = 'Påkrevd';
    if (!billingInfo?.phone?.trim()) errors.phone = 'Påkrevd';
    if (!billingInfo?.email?.trim()) errors.email = 'Påkrevd';
    setBillingErrors(errors);
    return Object.keys(errors)?.length === 0;
  };

  const handleBillingContinue = () => {
    if (validateBilling()) {
      setStep('confirm');
    } else {
      setShakeKey(k => k + 1);
    }
  };

  const handleConfirm = () => {
    if (!selectedPlan) return;
    onUpgrade(selectedPlan, billingInfo);
  };

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 300);
  };

  const handleBillingChange = (field, value) => {
    setBillingInfo(prev => ({ ...prev, [field]: value }));
    if (billingErrors?.[field]) setBillingErrors(prev => ({ ...prev, [field]: null }));
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        background: 'rgba(0,0,0,0.8)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '16px',
      }}
      onClick={(e) => { if (e?.target === e?.currentTarget) handleClose(); }}
    >
      <div
        style={{
          background: '#161B24',
          border: '1px solid rgba(59,111,212,0.25)',
          width: '100%',
          maxWidth: step === 'select' ? '860px' : '520px',
          maxHeight: '92vh',
          overflowY: 'auto',
          boxShadow: '0 24px 80px rgba(0,0,0,0.7)',
        }}
      >
        {/* Header */}
        <div style={{ background: '#1A2E52', padding: '20px 24px', borderBottom: '2px solid #3B6FD4', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ width: '4px', height: '28px', background: '#3B6FD4' }} />
            <div>
              <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '1.125rem', fontWeight: 800, color: '#EEF0F2', letterSpacing: '-0.03em' }}>
                {step === 'select' ? 'Velg abonnement' : step === 'billing' ? 'Fakturainformasjon' : 'Bekreft planbytte'}
              </div>
              <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', color: '#8A95A3', marginTop: '2px' }}>
                {step === 'select' ? 'Steg 1 av 3' : step === 'billing' ? 'Steg 2 av 3' : 'Steg 3 av 3'}
              </div>
            </div>
          </div>
          <button onClick={handleClose} style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: '#8A95A3', padding: '4px', display: 'flex' }}>
            <Icon name="X" size={20} color="currentColor" />
          </button>
        </div>

        {/* Step indicator */}
        <div style={{ display: 'flex', borderBottom: '1px solid rgba(138,149,163,0.08)' }}>
          {['Velg plan', 'Fakturering', 'Bekreft']?.map((label, i) => {
            const stepKeys = ['select', 'billing', 'confirm'];
            const isActive = step === stepKeys?.[i];
            const isDone = stepKeys?.indexOf(step) > i;
            return (
              <div key={i} style={{ flex: 1, padding: '10px 0', textAlign: 'center', borderBottom: isActive ? '2px solid #3B6FD4' : '2px solid transparent', background: isActive ? 'rgba(59,111,212,0.06)' : 'transparent' }}>
                <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', fontWeight: 600, color: isActive ? '#3B6FD4' : isDone ? '#2EC4A0' : '#8A95A3' }}>
                  {isDone ? '✓ ' : ''}{label}
                </span>
              </div>
            );
          })}
        </div>

        {/* STEP 1: Select plan */}
        {step === 'select' && (
          <div style={{ padding: '24px' }}>
            <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Icon name="Info" size={13} color="#8A95A3" />
              <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: '#8A95A3' }}>
                Nåværende plan: <span style={{ color: '#EEF0F2', fontWeight: 600 }}>{currentPlan}</span>
              </span>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '14px', marginBottom: '24px' }}>
              {PLANS?.map((plan) => {
                const isCurrent = plan?.name === currentPlan;
                const isSelected = selectedPlan?.id === plan?.id;
                return (
                  <div
                    key={plan?.id}
                    onClick={() => handleSelectPlan(plan)}
                    style={{
                      background: isSelected ? `${plan?.color}12` : '#0F1117',
                      border: isSelected ? `2px solid ${plan?.color}` : isCurrent ? '2px solid rgba(138,149,163,0.3)' : '1px solid rgba(255,255,255,0.07)',
                      padding: '18px',
                      cursor: isCurrent ? 'default' : 'pointer',
                      position: 'relative',
                      transition: 'all 200ms ease',
                      opacity: isCurrent ? 0.6 : 1,
                    }}
                  >
                    {plan?.popular && (
                      <div style={{ position: 'absolute', top: '-1px', right: '14px', background: '#E8941A', padding: '3px 10px', fontFamily: 'Syne, sans-serif', fontSize: '0.625rem', fontWeight: 800, color: '#0D0D0D', letterSpacing: '0.08em', textTransform: 'uppercase' }}>Populær</div>
                    )}
                    {isCurrent && (
                      <div style={{ position: 'absolute', top: '-1px', left: '14px', background: 'rgba(138,149,163,0.2)', padding: '3px 10px', fontFamily: 'Syne, sans-serif', fontSize: '0.625rem', fontWeight: 800, color: '#8A95A3', letterSpacing: '0.08em', textTransform: 'uppercase' }}>Nåværende</div>
                    )}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px', marginTop: (plan?.popular || isCurrent) ? '12px' : '0' }}>
                      <div style={{ width: '32px', height: '32px', background: `${plan?.color}18`, border: `1px solid ${plan?.color}30`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <Icon name={plan?.icon} size={14} color={plan?.color} />
                      </div>
                      <div>
                        <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.9375rem', fontWeight: 800, color: '#EEF0F2', letterSpacing: '-0.02em' }}>{plan?.name}</div>
                        <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', color: '#8A95A3' }}>{plan?.vehicles}</div>
                      </div>
                    </div>
                    <div style={{ marginBottom: '14px' }}>
                      <span style={{ fontFamily: 'Syne, sans-serif', fontSize: '1.5rem', fontWeight: 800, color: plan?.color, letterSpacing: '-0.04em' }}>{plan?.price}</span>
                      <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', color: '#8A95A3', marginLeft: '6px' }}>{plan?.period}</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                      {plan?.features?.map((f, i) => (
                        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <Icon name="Check" size={11} color={plan?.color} />
                          <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: '#EEF0F2' }}>{f}</span>
                        </div>
                      ))}
                      {plan?.notIncluded?.map((f, i) => (
                        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', opacity: 0.4 }}>
                          <Icon name="X" size={11} color="#8A95A3" />
                          <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: '#8A95A3' }}>{f}</span>
                        </div>
                      ))}
                    </div>
                    {isSelected && (
                      <div style={{ marginTop: '12px', display: 'flex', alignItems: 'center', gap: '6px', color: plan?.color }}>
                        <Icon name="CheckCircle2" size={13} color={plan?.color} />
                        <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', fontWeight: 600, color: plan?.color }}>Valgt</span>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button onClick={handleClose} style={{ padding: '10px 18px', background: 'transparent', border: '1px solid rgba(138,149,163,0.2)', color: '#8A95A3', fontFamily: 'Inter, sans-serif', fontSize: '0.875rem', cursor: 'pointer' }}>Avbryt</button>
              <button
                onClick={handleContinue}
                disabled={!selectedPlan}
                style={{ padding: '10px 22px', background: selectedPlan ? '#3B6FD4' : 'rgba(59,111,212,0.2)', border: 'none', color: selectedPlan ? '#fff' : '#8A95A3', fontFamily: 'Syne, sans-serif', fontSize: '0.875rem', fontWeight: 700, cursor: selectedPlan ? 'pointer' : 'not-allowed', display: 'flex', alignItems: 'center', gap: '8px', letterSpacing: '-0.01em' }}
              >
                Fortsett <Icon name="ArrowRight" size={14} color={selectedPlan ? '#fff' : '#8A95A3'} />
              </button>
            </div>
          </div>
        )}

        {/* STEP 2: Billing info */}
        {step === 'billing' && (
          <div style={{ padding: '24px' }}>
            <div style={{ marginBottom: '20px', padding: '12px 16px', background: 'rgba(59,111,212,0.06)', border: '1px solid rgba(59,111,212,0.2)', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Icon name="FileText" size={16} color="#3B6FD4" />
              <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: '#8A95A3' }}>
                Faktura for <strong style={{ color: '#EEF0F2' }}>{selectedPlan?.name}</strong> — <strong style={{ color: '#E8941A' }}>{selectedPlan?.price}</strong> vil bli sendt til oppgitt adresse.
              </span>
            </div>

            <div style={{ display: 'grid', gap: '14px' }}>
              {/* Full name */}
              <div>
                <label style={labelStyle}>Fullt navn *</label>
                <input
                  type="text"
                  value={billingInfo?.fullName}
                  onChange={e => handleBillingChange('fullName', e?.target?.value)}
                  placeholder="Ola Nordmann"
                  style={{ ...inputStyle, borderColor: billingErrors?.fullName ? '#E85555' : 'rgba(138,149,163,0.2)' }}
                  onFocus={e => e.target.style.borderColor = '#3B6FD4'}
                  onBlur={e => e.target.style.borderColor = billingErrors?.fullName ? '#E85555' : 'rgba(138,149,163,0.2)'}
                />
                {billingErrors?.fullName && <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', color: '#E85555', marginTop: '4px', display: 'block' }}>{billingErrors?.fullName}</span>}
              </div>

              {/* Company (optional) */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={labelStyle}>Firma (valgfritt)</label>
                  <input
                    type="text"
                    value={billingInfo?.company}
                    onChange={e => handleBillingChange('company', e?.target?.value)}
                    placeholder="Firma AS"
                    style={inputStyle}
                    onFocus={e => e.target.style.borderColor = '#3B6FD4'}
                    onBlur={e => e.target.style.borderColor = 'rgba(138,149,163,0.2)'}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Org.nr (valgfritt)</label>
                  <input
                    type="text"
                    value={billingInfo?.orgNumber}
                    onChange={e => handleBillingChange('orgNumber', e?.target?.value)}
                    placeholder="123 456 789"
                    style={inputStyle}
                    onFocus={e => e.target.style.borderColor = '#3B6FD4'}
                    onBlur={e => e.target.style.borderColor = 'rgba(138,149,163,0.2)'}
                  />
                </div>
              </div>

              {/* Address */}
              <div>
                <label style={labelStyle}>Gateadresse *</label>
                <input
                  type="text"
                  value={billingInfo?.address}
                  onChange={e => handleBillingChange('address', e?.target?.value)}
                  placeholder="Storgata 1"
                  style={{ ...inputStyle, borderColor: billingErrors?.address ? '#E85555' : 'rgba(138,149,163,0.2)' }}
                  onFocus={e => e.target.style.borderColor = '#3B6FD4'}
                  onBlur={e => e.target.style.borderColor = billingErrors?.address ? '#E85555' : 'rgba(138,149,163,0.2)'}
                />
                {billingErrors?.address && <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', color: '#E85555', marginTop: '4px', display: 'block' }}>{billingErrors?.address}</span>}
              </div>

              {/* Postal + City */}
              <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: '12px' }}>
                <div>
                  <label style={labelStyle}>Postnummer *</label>
                  <input
                    type="text"
                    value={billingInfo?.postalCode}
                    onChange={e => handleBillingChange('postalCode', e?.target?.value)}
                    placeholder="0155"
                    maxLength={4}
                    style={{ ...inputStyle, borderColor: billingErrors?.postalCode ? '#E85555' : 'rgba(138,149,163,0.2)' }}
                    onFocus={e => e.target.style.borderColor = '#3B6FD4'}
                    onBlur={e => e.target.style.borderColor = billingErrors?.postalCode ? '#E85555' : 'rgba(138,149,163,0.2)'}
                  />
                  {billingErrors?.postalCode && <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', color: '#E85555', marginTop: '4px', display: 'block' }}>{billingErrors?.postalCode}</span>}
                </div>
                <div>
                  <label style={labelStyle}>Poststed *</label>
                  <input
                    type="text"
                    value={billingInfo?.city}
                    onChange={e => handleBillingChange('city', e?.target?.value)}
                    placeholder="Oslo"
                    style={{ ...inputStyle, borderColor: billingErrors?.city ? '#E85555' : 'rgba(138,149,163,0.2)' }}
                    onFocus={e => e.target.style.borderColor = '#3B6FD4'}
                    onBlur={e => e.target.style.borderColor = billingErrors?.city ? '#E85555' : 'rgba(138,149,163,0.2)'}
                  />
                  {billingErrors?.city && <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', color: '#E85555', marginTop: '4px', display: 'block' }}>{billingErrors?.city}</span>}
                </div>
              </div>

              {/* Phone + Email */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={labelStyle}>Telefon *</label>
                  <input
                    type="tel"
                    value={billingInfo?.phone}
                    onChange={e => handleBillingChange('phone', e?.target?.value)}
                    placeholder="+47 900 00 000"
                    style={{ ...inputStyle, borderColor: billingErrors?.phone ? '#E85555' : 'rgba(138,149,163,0.2)' }}
                    onFocus={e => e.target.style.borderColor = '#3B6FD4'}
                    onBlur={e => e.target.style.borderColor = billingErrors?.phone ? '#E85555' : 'rgba(138,149,163,0.2)'}
                  />
                  {billingErrors?.phone && <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', color: '#E85555', marginTop: '4px', display: 'block' }}>{billingErrors?.phone}</span>}
                </div>
                <div>
                  <label style={labelStyle}>E-post *</label>
                  <input
                    type="email"
                    value={billingInfo?.email}
                    onChange={e => handleBillingChange('email', e?.target?.value)}
                    placeholder="ola@example.no"
                    style={{ ...inputStyle, borderColor: billingErrors?.email ? '#E85555' : 'rgba(138,149,163,0.2)' }}
                    onFocus={e => e.target.style.borderColor = '#3B6FD4'}
                    onBlur={e => e.target.style.borderColor = billingErrors?.email ? '#E85555' : 'rgba(138,149,163,0.2)'}
                  />
                  {billingErrors?.email && <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', color: '#E85555', marginTop: '4px', display: 'block' }}>{billingErrors?.email}</span>}
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '24px' }}>
              <button onClick={() => setStep('select')} style={{ padding: '10px 18px', background: 'transparent', border: '1px solid rgba(138,149,163,0.2)', color: '#8A95A3', fontFamily: 'Inter, sans-serif', fontSize: '0.875rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <Icon name="ArrowLeft" size={13} color="currentColor" /> Tilbake
              </button>
              <button
                onClick={handleBillingContinue}
                style={{ padding: '10px 22px', background: '#3B6FD4', border: 'none', color: '#fff', fontFamily: 'Syne, sans-serif', fontSize: '0.875rem', fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', letterSpacing: '-0.01em' }}
              >
                Fortsett <Icon name="ArrowRight" size={14} color="#fff" />
              </button>
            </div>
          </div>
        )}

        {/* STEP 3: Confirm */}
        {step === 'confirm' && selectedPlan && (
          <div style={{ padding: '24px' }}>
            <div style={{ background: '#0F1117', border: '1px solid rgba(255,255,255,0.07)', padding: '18px', marginBottom: '16px' }}>
              <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.6875rem', color: '#8A95A3', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '14px' }}>Planbytte oversikt</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                <div style={{ flex: 1, minWidth: '100px' }}>
                  <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', color: '#8A95A3', marginBottom: '4px' }}>Fra</div>
                  <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '1rem', fontWeight: 700, color: '#EEF0F2' }}>{currentPlan}</div>
                </div>
                <Icon name="ArrowRight" size={16} color="#3B6FD4" />
                <div style={{ flex: 1, minWidth: '100px' }}>
                  <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', color: '#8A95A3', marginBottom: '4px' }}>Til</div>
                  <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '1rem', fontWeight: 700, color: selectedPlan?.color }}>{selectedPlan?.name}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', color: '#8A95A3', marginBottom: '4px' }}>Månedlig</div>
                  <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '1.25rem', fontWeight: 800, color: '#E8941A', letterSpacing: '-0.03em' }}>{selectedPlan?.price}</div>
                </div>
              </div>
            </div>

            {selectedPlan?.priceNum > 0 && billingInfo?.fullName && (
              <div style={{ background: '#0F1117', border: '1px solid rgba(255,255,255,0.07)', padding: '14px 18px', marginBottom: '16px' }}>
                <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.6875rem', color: '#8A95A3', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '10px' }}>Faktureres til</div>
                <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.875rem', color: '#EEF0F2', lineHeight: 1.7 }}>
                  <strong>{billingInfo?.fullName}</strong>
                  {billingInfo?.company && <><br />{billingInfo?.company}</>}
                  <br />{billingInfo?.address}<br />
                  {billingInfo?.postalCode} {billingInfo?.city}<br />
                  {billingInfo?.phone} · {billingInfo?.email}
                </div>
              </div>
            )}

            <div style={{ background: 'rgba(59,111,212,0.06)', border: '1px solid rgba(59,111,212,0.2)', padding: '14px 16px', marginBottom: '20px', display: 'flex', gap: '10px' }}>
              <Icon name="FileText" size={16} color="#3B6FD4" style={{ flexShrink: 0, marginTop: '2px' }} />
              <div>
                <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.9375rem', fontWeight: 700, color: '#EEF0F2', marginBottom: '3px' }}>PDF-faktura lastes ned automatisk</div>
                <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: '#8A95A3', lineHeight: 1.5 }}>
                  En faktura på <strong style={{ color: '#EEF0F2' }}>{selectedPlan?.price}</strong> genereres og lagres i fakturahistorikken din.
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button
                onClick={() => setStep(selectedPlan?.priceNum === 0 ? 'select' : 'billing')}
                style={{ padding: '10px 18px', background: 'transparent', border: '1px solid rgba(138,149,163,0.2)', color: '#8A95A3', fontFamily: 'Inter, sans-serif', fontSize: '0.875rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
              >
                <Icon name="ArrowLeft" size={13} color="currentColor" /> Tilbake
              </button>
              <button
                onClick={handleConfirm}
                disabled={isLoading}
                style={{
                  padding: '10px 22px',
                  background: isLoading ? 'rgba(232,148,26,0.3)' : '#E8941A',
                  border: 'none',
                  color: isLoading ? '#8A95A3' : '#0D0D0D',
                  fontFamily: 'Syne, sans-serif', fontSize: '0.875rem', fontWeight: 800,
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  display: 'flex', alignItems: 'center', gap: '8px',
                  letterSpacing: '-0.01em',
                  boxShadow: isLoading ? 'none' : '3px 3px 0 rgba(232,148,26,0.25)',
                }}
              >
                <Icon name={isLoading ? 'Loader2' : 'FileText'} size={14} color={isLoading ? '#8A95A3' : '#0D0D0D'} />
                {isLoading ? 'Behandler...' : 'Bekreft og last ned faktura'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export { PLANS, generatePDF };
export default UpgradePlanModal;
